export enum Pages {
  Edit = 'edit',
  Detail = 'detail',
}
